import { HierarchyLevels, PackageType } from '@retail/products/types';
import { ItemAgreementDTO, PriceType } from '../dto';

export interface ItemAgreementPricesProps {
  agreementId: number;
  agreementNumber: number;
  agreementText: string;
  price: number;
  priceUnit: string;
  packagePrice: number;
  packagePriceUnit: string;
  priceType: PriceType;
  packageType: PackageType;
  isActive: boolean;
  bindingType?: HierarchyLevels;
}

export class ItemAgreementPrices {
  agreementId: number;
  agreementNumber: number;
  agreementText: string;
  price: number;
  priceUnit: string;
  packagePrice: number;
  packagePriceUnit: string;
  priceType: PriceType;
  packageType: PackageType;
  isActive: boolean;
  bindingType?: HierarchyLevels;

  constructor({
    agreementId,
    agreementNumber,
    agreementText,
    price,
    priceUnit,
    packagePrice,
    packagePriceUnit,
    priceType,
    packageType,
    isActive,
    bindingType,
  }: ItemAgreementPricesProps) {
    this.agreementId = agreementId;
    this.agreementNumber = agreementNumber;
    this.agreementText = agreementText;
    this.price = price;
    this.priceUnit = priceUnit;
    this.packagePrice = packagePrice;
    this.packagePriceUnit = packagePriceUnit;
    this.priceType = priceType;
    this.packageType = packageType;
    this.isActive = isActive;
    this.bindingType = bindingType;
  }

  getId = (): string => `${this.agreementId}-${this.packagePriceUnit}`;

  static fromDto = (dto: ItemAgreementDTO): ItemAgreementPrices =>
    new ItemAgreementPrices({
      agreementId: dto.agreementId,
      agreementNumber: dto.agreementNumber,
      agreementText: dto.agreementText,
      price: dto.price,
      priceUnit: dto.priceUnit,
      packagePrice: dto.packagePrice,
      packagePriceUnit: dto.packagePriceUnit,
      priceType: dto.priceType,
      packageType: dto.packageType,
      isActive: dto.isActive,
      bindingType: dto.bindingType,
    });
}
